document.addEventListener("DOMContentLoaded", () => {

    const isMobile = () => window.innerWidth <= 768;

    const hotspots = document.querySelectorAll(".stl-v2__hotspot");

    const drawer = document.querySelector(".stl-v2-drawer");
    const drawerContent = document.getElementById("stl-v2-drawer-content");

    /* ==========================================
       Mobile Drawer
    ========================================== */

    function openMobileDrawer(hotspot){

        if(!drawer || !drawerContent) return;

        drawerContent.innerHTML = `
            <img src="${hotspot.dataset.image}" class="stl-v2-mobile-image">

            <h3 class="stl-v2-mobile-title">
                ${hotspot.dataset.title}
            </h3>

            <p class="stl-v2-mobile-price">
                ${hotspot.dataset.price}
            </p>

            <a href="${hotspot.dataset.url}" class="stl-v2__button">
                View Product
            </a>
        `;

        drawer.classList.add("active");

    }

    hotspots.forEach(hotspot => {

        hotspot.addEventListener("click", function(e){

            if(!isMobile()) return;

            e.preventDefault();
            e.stopPropagation();

            openMobileDrawer(hotspot);

        });

    });

    if(drawer){

        const closeButton = drawer.querySelector(".stl-v2-drawer__close");
        const overlay = drawer.querySelector(".stl-v2-drawer__overlay");

        closeButton?.addEventListener("click", () => {

            drawer.classList.remove("active");

        });

        overlay?.addEventListener("click", () => {

            drawer.classList.remove("active");

        });

    }

    /* ==========================================
       Draw Connector Lines
    ========================================== */

    function drawConnectorLines(){

        if(isMobile()) return;

        const container = document.querySelector(".stl-v2__look");
        if(!container) return;

        const svg = container.querySelector(".stl-v2__lines");
        if(!svg) return;

        svg.innerHTML = "";

        const containerRect = container.getBoundingClientRect();

        hotspots.forEach(hotspot => {

            const card = document.getElementById("card-" + hotspot.dataset.card);

            if(!card) return;

            const hotspotRect = hotspot.getBoundingClientRect();
            const cardRect = card.getBoundingClientRect();

            const startX =
                hotspotRect.left +
                hotspotRect.width / 2 -
                containerRect.left;

            const startY =
                hotspotRect.top +
                hotspotRect.height / 2 -
                containerRect.top;

            const cardCenterX = cardRect.left + cardRect.width / 2;
            const cardCenterY = cardRect.top + cardRect.height / 2;

            let endX;
            let endY;

            if(cardCenterX < hotspotRect.left){

                endX = cardRect.right - containerRect.left;

            }else{

                endX = cardRect.left - containerRect.left;

            }

            endY = cardCenterY - containerRect.top;

            const path = document.createElementNS(
                "http://www.w3.org/2000/svg",
                "path"
            );

            const curve = `
                M ${startX} ${startY}
                C ${(startX + endX) / 2} ${startY},
                  ${(startX + endX) / 2} ${endY},
                  ${endX} ${endY}
            `;

            path.setAttribute("d", curve);
            path.setAttribute("class", "stl-v2__connector");

            svg.appendChild(path);

        });

    }

    drawConnectorLines();

    window.addEventListener("resize", () => {

        if(drawer){

            drawer.classList.remove("active");

        }

        drawConnectorLines();

    });

    window.addEventListener("load", drawConnectorLines);

});